export default "__VITE_ASSET__CzDYvxr4__"